<template>
  <table class="status-card" v-loading="cardObject.loading">
    <c-caption
      v-if="TitleShow"
      :cardObject="cardObject"
      :editType.sync="editType"
      :title="title"
    ></c-caption>
    <c-td
      :editType.sync="editType"
      :cardObject="cardObject"
      :clickEventManger="clickEventManger"
    ></c-td>
  </table>
</template>
<script>
import CTd from './components/CTd'
import CCaption from './components/CCaption'
export default {
  name: 'status-card',
  data: function () {
    return {
      editType: false,
      clickEventManger: {
        cMap: {},
        on (event, key, value) {
          if (!this.cMap[event]) {
            this.cMap[event] = {
              queue: new Map()
            }
          }
          this.cMap[event].queue.set(key, value)
        },
        emit (event) {
          if (this.cMap[event]) {
            if (!this.cMap[event]) return false
            const queue = this.cMap[event].queue
            const iterator = queue.entries()
            let res = iterator.next()
            while (!res.done) {
              const [thiz, fn] = res.value
              fn.apply(thiz)
              res = iterator.next()
            }
          }
        },
        off (event, key) {
          if (!this.cMap[event]) return false
          const queue = this.cMap[event].queue
          if (queue && queue.has(key)) {
            queue.delete(key)
          }
        }
      }
    }
  },
  components: {
    CTd,
    CCaption
  },
  watch: {
    student (newVal) {
      this.editType = false
    }
  },
  props: {
    cardObject: {
      type: Object,
      default: () => {
        return {
          tableData: [],
          editType: false,
          row: 0,
          column: 0,
          loading: true
        }
      }
    },
    title: {
      type: String
    },
    TitleShow: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style lang="scss" scoped>
@import './components/main.scss';
.status-card {
  width: 1000px;
  height: max-content;
  background: #ffffff;
  @include table-border-around();
}
</style>



// WEBPACK FOOTER //
// src/components/common/student-status-card/components/StatusCard/index.vue